<template>
  <md-dialog
    ref="modal"
    :ref-name="refName"
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    class="printer-plugin-download-modal"
  >
    <div class="flex justify-between items-center">
      <md-dialog-title>
        Ops...
        {{ connectionState !== 'hasNewVersion' ? 'Não detectamos o plugin de impressão neste computador!' : 'Plugin de impressão desatualizado!' }}
      </md-dialog-title>

      <PrinterHelpButton style="padding: 33px 24px 12px 12px" />
    </div>

    <md-dialog-content>
      <p
        v-if="connectionState !== 'hasNewVersion'"
        class="mb-6"
      >
        Para imprimir etiquetas aqui, siga as instruções:

        <ul>
          <li>Caso já tenha instalado anteriormente, localize na sua área de trabalho o atalho <strong>"AOL 2.0 Plugin de Impressão"</strong> e execute.</li>
          <li>Caso contrário, clique em <strong>"Baixar Plugin"</strong>, instale o arquivo e aguarde a inicialização para habilitar a impressão.</li>
        </ul>
      </p>
      <p
        v-else
        class="mb-6"
      >
        Baixe a nova versão para continuar usando o sistema!
      </p>
      <div class="flex justify-between mt-4">
        <button
          class="btn btn-primary md-button"
          @click="close"
        >
          Fechar
        </button>

        <a
          :href="downloadUrl"
          class="btn btn-primary md-button flex align-center"
          @click="close"
        >
          {{ connectionState !== 'hasNewVersion' ? 'Baixar plugin' : 'Baixar nova versão' }}
        </a>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PrinterHelpButton from '@/components/common/printer/PrinterHelpButton.vue';

export default {
  name: 'PrinterPluginDownloadModal',
  components: {
    PrinterHelpButton,
  },
  props: {
    refName: {
      type: String,
      default: 'printerPluginDownloadModal',
    },
    downloadUrl: {
      type: String,
      default: 'https://storageapoiob2bprd.blob.core.windows.net/printer-plugin/AOL2_0PlugindeImpressão.exe',
    },
  },
  computed: {
    ...mapGetters(['webSocketStatus', 'isPrinterPluginModalVisible']),
    connectionState() {
      if (this.webSocketStatus?.connectionState === 'connected' && this.webSocketStatus?.hasNewVersion) {
        return 'hasNewVersion';
      }
      return this.webSocketStatus?.connectionState || 'disconnected';
    },
  },
  mounted() {
    this.$refs.modal.$el.addEventListener('md-closed', () => {
      this.setPrinterPluginModalVisible(false);
    });
  },
  methods: {
    ...mapActions(['setPrinterPluginModalVisible']),
    open() {
      if (!this.isPrinterPluginModalVisible) {
        this.setPrinterPluginModalVisible(true);
        this.$refs.modal.open();
      }
    },
    close() {
      this.setPrinterPluginModalVisible(false);
      this.$refs.modal.close();
    }
  },
};
</script>

<style lang="scss" scoped>

.printer-plugin-download-modal {

  ul {
    padding: 0 15px;
    margin-top: 18px;
  }

  ul, li {
    list-style: disc;
  }
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}
</style>
